<template>
  <woot-button
    size="small"
    icon="arrow-right-import"
    view-box="0 0 20 20"
    variant="smooth"
    color-scheme="secondary"
    class="toggle-sidebar-header"
    :class="{ expanded: !isOnExpandedSidebar }"
    @click="onMenuItemClick"
  />
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  props: {
    isOnExpandedSidebar: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onMenuItemClick() {
      bus.$emit(BUS_EVENTS.TOGGLE_SIDEMENU);
    },
  },
};
</script>
<style lang="scss">
.toggle-sidebar-header {
  margin-left: var(--space-minus-small);
  &.expanded .icon {
    transform: rotate(180deg) !important;
  }
}
</style>
